<script module lang="ts">
  import Layout from '../components/Layout.svelte'
  import { translate } from '../i18n'
  import type { Locale } from '../translations'

  export const layout = (props: { locale: Locale }) => ({
    component: Layout,
    props: { title: translate(props.locale, 'footer.privacy') },
  })
</script>

<script lang="ts">
  import LegalPage from '../components/LegalPage.svelte'
  import OperatorAddress from '../components/OperatorAddress.svelte'
  import OperatorEmail from '../components/OperatorEmail.svelte'
  import { getI18n } from '../i18n'

  const i18n = getI18n()
</script>

<LegalPage title={i18n.t('footer.privacy')}>
  <p class="privacy-intro">{i18n.t('privacy.intro')}</p>

  <h2 class="privacy-heading">{i18n.t('privacy.controller.heading')}</h2>
  <p>{i18n.t('privacy.controller.text')}</p>
  <OperatorAddress />
  <OperatorEmail />

  <h2 class="privacy-heading">{i18n.t('privacy.hosting.heading')}</h2>
  <p>{i18n.t('privacy.hosting.text')}</p>

  <h2 class="privacy-heading">{i18n.t('privacy.serverLogs.heading')}</h2>
  <p>{i18n.t('privacy.serverLogs.text')}</p>

  <h2 class="privacy-heading">{i18n.t('privacy.analytics.heading')}</h2>
  <p>{i18n.t('privacy.analytics.text')}</p>

  <h2 class="privacy-heading">{i18n.t('privacy.errorReports.heading')}</h2>
  <p>{i18n.t('privacy.errorReports.text')}</p>

  <h2 class="privacy-heading">{i18n.t('privacy.cookies.heading')}</h2>
  <p>{i18n.t('privacy.cookies.text')}</p>

  <h2 class="privacy-heading">{i18n.t('privacy.rights.heading')}</h2>
  <p>{i18n.t('privacy.rights.text')}</p>
  <ul>
    <li>{i18n.t('privacy.rights.access')}</li>
    <li>{i18n.t('privacy.rights.rectification')}</li>
    <li>{i18n.t('privacy.rights.erasure')}</li>
    <li>{i18n.t('privacy.rights.restriction')}</li>
    <li>{i18n.t('privacy.rights.portability')}</li>
    <li>{i18n.t('privacy.rights.objection')}</li>
  </ul>
  <p class="privacy-email-label">{i18n.t('privacy.rights.contact')}</p>
  <OperatorEmail />

  <h2 class="privacy-heading">{i18n.t('privacy.complaint.heading')}</h2>
  <p>{i18n.t('privacy.complaint.text')}</p>

  <p class="privacy-updated">{i18n.t('privacy.updated')}</p>
</LegalPage>

<style>
  .privacy-intro {
    margin-top: var(--space-9);
  }

  .privacy-heading {
    margin-top: var(--space-10);
  }

  .privacy-email-label {
    margin-bottom: 0;
  }

  .privacy-updated {
    margin-top: var(--space-10);
    font-size: var(--font-size-4);
    color: var(--color-text-muted);
  }
</style>
